import { isString } from '@grafana/faro-core';
// This code parses the headers from an XMLHttpRequest and returns them as an object.
export const parseXHRHeaders = (context) => {
    const headers = context.getAllResponseHeaders().split('\r\n');
    const headerMap = {};
    for (const header of headers) {
        const [key, value] = header.split(': ');
        if (key && value) {
            headerMap[`header_${key}`] = value;
        }
    }
    return headerMap;
};
// This code parses the xhr event and returns a record of the request url, response url, bytes loaded, status text, and status code.
export const parseXHREvent = (context, event) => {
    var _a, _b, _c, _d, _e;
    // @ts-expect-error - _url is attached to the xhr object in XMLHttpRequest.prototype.open
    const { _url, responseURL, statusText, status } = context;
    return {
        request_url: (_a = _url === null || _url === void 0 ? void 0 : _url.toString()) !== null && _a !== void 0 ? _a : '',
        response_url: (_b = responseURL === null || responseURL === void 0 ? void 0 : responseURL.toString()) !== null && _b !== void 0 ? _b : '',
        bytes_loaded: (_d = (_c = event.loaded) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '',
        status_text: statusText !== null && statusText !== void 0 ? statusText : '',
        status: (_e = status === null || status === void 0 ? void 0 : status.toString()) !== null && _e !== void 0 ? _e : '',
    };
};
export function shouldPropagateRumHeaders(url, propagateRumHeaderCorsUrls = []) {
    return propagateRumHeaderCorsUrls.some((pattern) => {
        return isString(pattern) ? url.includes(pattern) : Boolean(url.match(pattern));
    });
}
//# sourceMappingURL=utils.js.map